<template>
  <div class="documents-screen">
    <page-header :title="$t('app.documents.title')"/>
    <div class="row mt-20">
      <div class="col-sm-6">
        <search-input :placeholder="$t('app.documents.search_input_placeholder')" @input="search"/>
      </div>
      <div class="col-sm-6 text-right">
        <base-button
          v-if="hasPermission"
          :title="$t('app.folders.set_folder')"
          classNames="btn btn-orange rounded pull-right"
          @clicked="addFolder"
        />
      </div>
    </div>
    <ul v-if="treeData.length > 0" class="cd-accordion-menu">
      <li>
        <label>
          <div class="row">
            <div class="col-md-12 header-row">
              <div class="col-md-3">
                {{$t('app.tables.documents.name')}}
              </div>
              <div class="col-md-7">
                {{$t('app.tables.documents.description')}}
              </div>
              <div class="col-md-2 extra-row">
                {{$t('app.tables.global.actions')}}
              </div>
            </div>
          </div>
        </label>
      </li>
      <document-item 
        v-for="(data,index) in treeData"
        :isSearch="isSearch"
        :selectedIndex="index"
        :key="index"
        :bus="bus"
        :model="data"
        :needAction="hasPermission"/>
    </ul>
  </div>
</template>

<script>
import Vue from 'vue';

import { mapActions, mapGetters } from "vuex";
import ConfigurableList from "@/components/shared/lists/ConfigurableList";
import SearchInput from "@/components/shared/inputs/SearchInput";
import BaseButton from "@/components/shared/buttons/BaseButton";
import Paginator from "@/components/shared/navigations/Paginator";
import GenericForm from "@/components/shared/forms/GenericForm";
import PageHeader from "@/components/shared/layouts/PageHeader";
import NavBar from "@/components/shared/navigations/NavBar";
import DocumentItem from "./DocumentItem";

export default {
  name: "DocumentsScreen",
  components: {
    "search-input": SearchInput,
    "base-button": BaseButton,
    "search-input": SearchInput,
    "configurable-list": ConfigurableList,
    "paginator-component": Paginator,
    "nav-bar": NavBar,
    "page-header": PageHeader,
    "document-item": DocumentItem
  },
  data() {
    return {
      isSearch: false,
      treeData: [],
      bus: new Vue(),
      loadingText: '',
      currentPageIndex: 1,
      searchTerm: "",
      document: undefined,
      newDocument: {
        name: undefined,
        description: undefined,
        owner_partner_id: undefined,
        file: undefined
      },
      selected: 0,
      order: undefined,
      direction: undefined,
      folderAttributes: [
        {
          name: "name",
          type: "text"
        }
      ],
      newFolder: {
        name: undefined,
        parent_id: undefined,
        level: undefined
      },
    };
  },
  created() {
    this.loadingText = this.$t('app.listLoading')
    if (this.loggedInUser) {
      this.fetchFolderTree().then(response => {
        this.treeData = response
      })
    }
  },
  computed: {
    ...mapGetters({
      allDocuments: "documents/allDocuments",
      allPartners: "partners/allPartners",
      loggedInUser: "loggedInUser",
    }),
    hasPermission() {
      return this.loggedInUser.role === 'admin' || this.loggedInUser.role === 'partner_admin'
    },
    totalPages() {
      return this.allDocuments.total_pages || 0;
    },
    partnersForList() {
      const mappedPartners = this.allPartners.partners.map(function(
        partner
      ) {
        return {
          value: partner.id,
          text: partner.name
        };
      });
      return mappedPartners;
    },
    documentAttributes() {
      if(this.loggedInUser.role === 'admin') {
        return [
          {
            name: "name",
            type: "text",
          },
          {
            name: "description",
            type: "text-area",
          },
          {
            name: "file",
            type: "file",
            multiple: false,
          }
        ];
      } else {
        return [
          {
            name: "name",
            type: "text",
          },
          {
            name: "description",
            type: "text-area",
          },
          {
            name: "file",
            type: "file",
            multiple: false,
          }
        ];
      }
    },
    filter() {
      switch(this.selected) {
        case 0: {
          return 'all';
          break;
        }
        case 1: {
          return 'lay';
          break;
        }
        case 2: {
          return 'other';
          break;
        }
        default: {
          return 'all';
          break;
        }
      }
    },
  },
  mounted() {},
  methods: {
    ...mapActions({
      createFolder: "folders/createFolder",
      searchInFolder: "folders/searchInFolder",
      fetchDocuments: "documents/fetchDocuments",
      fetchDocument: "documents/fetchDocument",
      createNewDocument: "documents/createDocument",
      updateDocumentParams: "documents/updateDocument",
      deleteDocument: "documents/deleteDocument",
      fetchPartners: "partners/fetchPartners",
      fetchFolderTree: "folders/fetchFolderTree",
      fetchFolderTreeChild: "folders/fetchFolderTreeChild",
    }),
    resetFolder() {
      Object.assign(
        this.$data.newFolder,
        this.$options.data().newFolder
      );
    },
    createNewFolder(newFolder) {
      newFolder.level = 0
      this.createFolder(newFolder).then(response => {
        response.type = 0;
        this.treeData.push(response)
        this.$eventBus.showNotification({
          notificationText: this.$t("app.folders.create"),
          notificationType: "success"
        });
        this.resetFolder();
        this.$eventBus.hideModal();
      })
      .catch(error => {
          this.$eventBus.stopLoading()
          const mappedErrors = error.map(x => ` ${x}`);
          this.$eventBus.getError(mappedErrors)
        });
    },
    addFolder() {
      this.$eventBus.showModal({
        bind: {
          is: GenericForm,
          title: this.$t(
            "app.folders.set_folder"
          ),
          fields: this.folderAttributes,
          model: this.newFolder,
          submitTitle: this.$t("app.verification_questions.buttons.save"),
          cancelTitle: this.$t("app.verification_questions.buttons.cancel"),
          modelName: "folders"
        },
        on: {
          submit: this.createNewFolder,
          modalCanceled: this.resetFolder,
        }
      });
    },
    getChildren(child,index) {
      if(child.children && child.children.length > 0) {
        child.children.forEach(x => {
          x.main_idx = index
        })
      }
    },
    search(keyword) {
      this.searchTerm = keyword;
      if(this.searchTerm !== '') {
        this.isSearch = true
        this.searchInFolder(this.searchTerm).then(response => {
          this.treeData = response
        })
      } else {
        this.fetchFolderTree().then(response => {
          this.treeData = response
          this.isSearch = false
        })
      }
      
    },
    clickedCreateDocument() {
      this.$eventBus.showModal({
        bind: {
          is: GenericForm,
          title: this.$t("app.documents.set_document"),
          fields: this.documentAttributes,
          model: this.newDocument,
          submitTitle: this.$t("app.documents.buttons.save"),
          cancelTitle: this.$t("app.documents.buttons.cancel"),
          modelName: "documents"
        },
        on: {
          submit: this.createDocument,
          modalCanceled: this.resetNewDocument
        }
      });
    },
    actionMade(payload) {
      if (payload.actionType == "edit") {
        this.fetchDocument(payload.id)
          .then(response => {
            this.document = response;
            this.$eventBus.showModal({
              bind: {
                is: GenericForm,
                title: this.$t("app.documents.edit_document"),
                fields: this.documentAttributes,
                model: this.document,
                submitTitle: this.$t("app.documents.buttons.save"),
                cancelTitle: this.$t("app.documents.buttons.cancel"),
                modelName: "documents"
              },
              on: {
                submit: this.updateDocument
              }
            });
          })
          .catch(error => {
            const mappedErrors = error.map(x => ` ${x}`);
            const errorMessages = this.$t("app.errors.general_validation", {
              message: mappedErrors
            });
            this.$swal
              .fire({
                html: errorMessages,
                type: "error",
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                focusConfirm: false,
              })
          });
      } else if (payload.actionType == "delete") {
        this.$swal
        .fire({
          html: this.$t("app.notifications.general_confirm.title"),
          type: "info",
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: this.$t("app.notifications.general_confirm.ok"),
          cancelButtonText: this.$t("app.notifications.general_confirm.cancel")
        })
        .then(result => {
          if(result.value) {
            const previousTotalPages = this.totalPages
            this.deleteDocument(payload.id)
            .then(response => {
              this.$eventBus.showNotification({
                notificationText: this.$t("app.documents.success.delete"),
                notificationType: "success"
              });
              this.fetchDocuments({
                pageIndex: this.currentPageIndex,
                searchTerm: this.searchTerm
              }).then(resposne => {
                if(resposne.documents.length === 0) {
                  this.loadingText = this.$t('app.tasks.empty_list')
                }
                if(this.totalPages < previousTotalPages) {
                  this.currentPageIndex = this.totalPages;
                }
              })
            })
            .catch(error => {
              this.$swal
              .fire({
                html: error[0],
                type: "error",
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                focusConfirm: false,
              })
            });
          }
        });
        
      }
    },
    createDocument(newDocument) {
      this.createNewDocument(newDocument)
        .then(response => {
          this.$eventBus.showNotification({
            notificationText: this.$t("app.documents.success.create"),
            notificationType: "success"
          });
          this.fetchDocuments({
            pageIndex: this.currentPageIndex,
            searchTerm: this.searchTerm,
          })
            .then(response => {
              this.$refs.navbar.selectedTab = 0
              this.resetNewDocument();
              this.$eventBus.hideModal();
            })
            .catch(error => {
              this.$swal
              .fire({
                html: error[0],
                type: "error",
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                focusConfirm: false,
              })
            });
        })
        .catch(error => {
            this.$eventBus.stopLoading()
            const mappedErrors = error.map(x => ` ${x}`);
            this.$eventBus.getError(mappedErrors)
        });
    },
    updateDocument(document) {
      this.updateDocumentParams(document)
        .then(response => {
          this.$eventBus.showNotification({
            notificationText: this.$t("app.documents.success.update"),
            notificationType: "success"
          });
          this.fetchDocuments({
            pageIndex: this.currentPageIndex,
            searchTerm: this.searchTerm
          })
            .then(response => {
              this.$eventBus.hideModal();
            })
            .catch(error => {
              this.$swal
              .fire({
                html: error[0],
                type: "error",
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                focusConfirm: false,
              })
            });
        })
        .catch(error => {
            this.$eventBus.stopLoading()
            const mappedErrors = error.map(x => ` ${x}`);
            this.$eventBus.getError(mappedErrors)
        });
    },
    itemSelected(index) {
      this.currentPageIndex = index;
    },
    resetNewDocument() {
      Object.assign(this.$data.newDocument, this.$options.data().newDocument);
    },
    tabChanged(index) {
      this.selected = index;
      this.currentPageIndex = 1;
    },
    orderTable(payload) {
      this.order = payload.order;
      this.direction = payload.direction;
      if(this.filter === 'all') {
        this.fetchDocuments({
          pageIndex: this.currentPageIndex,
          searchTerm: this.searchTerm,
          orderInfo: {
            order: payload.order,
            direction: payload.direction
          }
        });
      } else {
        this.fetchDocuments({
          pageIndex: this.currentPageIndex,
          searchTerm: this.searchTerm,
          type: this.filter,
          orderInfo: {
            order: payload.order,
            direction: payload.direction
          }
        });
      }
    }
  },
  watch: {
    currentPageIndex(newValue, oldValue) {
      if(this.filter === 'all') {
        if(this.order !== undefined && this.direction !== undefined) {
          this.fetchDocuments({
            pageIndex: newValue,
            searchTerm: this.searchTerm,
            orderInfo: {
              order: this.order,
              direction: this.direction
            }
          });
        } else {
          this.fetchDocuments({
            pageIndex: newValue,
            searchTerm: this.searchTerm
          });
        }
      } else {
        if(this.order !== undefined && this.direction !== undefined) {
        } else {
          this.fetchDocuments({
            pageIndex: newValue,
            searchTerm: this.searchTerm,
            type: this.filter,
            orderInfo: {
              order: this.order,
              direction: this.direction
            }
          });
        }
        this.fetchDocuments({
          pageIndex: newValue,
          searchTerm: this.searchTerm,
          type: this.filter,
        });
      }
    },
    selected(newVal,oldVal) {
      if(newVal === 0) {
        this.fetchDocuments({
          pageIndex: this.currentPageIndex,
          searchTerm: this.searchTerm
        }).then(response => {
          if(response.documents.length === 0) {
            this.loadingText = this.$t('app.tasks.empty_list')
          }
        });;
      } else {
        this.fetchDocuments({
          pageIndex: this.currentPageIndex,
          searchTerm: this.searchTerm,
          type: this.filter,
        }).then(response => {
          if(response.documents.length === 0) {
            this.loadingText = this.$t('app.tasks.empty_list')
          }
        });;
      }
    }
  }
};
</script>

<style lang="scss">
.documents-screen {
  .extra-row {
    display: flex;
    justify-content: center;
  }
  
  .header-row, .name-col {
    padding-left: 0;
  }

  .header-row {
    color: #000000 !important;
    font-weight: 500;
    display: flex;
    align-items: center;
  }

  .documents-list {
    padding-left: 9px;
    padding-right: 9px;
  }
  li {
    cursor: pointer;
  }

  li.is-active {
    border-bottom: 2px solid var(--main-color);
  }

  li.is-active > a {
    color: var(--main-color);
  }

  .rounded {
    border-radius: 4px;
  }

  .name-cell {
    width: 25%;
  }

  .description-cell {
    width: 25%;
  }

  .type-cell {
    width: 20%;
  }

  .asset-cell {
    width: 15%;
  }

  .edit-cell {
    width: 5%;
  }

  .delete-cell {
    width: 5%;
  }

  .tag {
    background: var(--main-color);
    border-radius: 4px;
    color: #ffffff;
    font-size: 11px;
    padding: 3px 0px 3px 0px;
    float: left;
    min-width: 85px;
    text-align: center;
  }

  ol, ul {
    list-style: none;
    padding: 0px;
  }

  a {
    color: #a0f6aa;
    text-decoration: none;
  }

  h1 {
    text-align: center;
    width: 90%;
    margin: 2em auto 0;
    color: #507b55;
    font-weight: bold;
  }

  .cd-accordion-menu {
    width: 100%;
    margin: 1em auto;
    background: rgba(0, 0, 0, 0.8);
    box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.3);
  }

  .cd-accordion-menu li {
    user-select: none;
    background: rgba(243, 243, 243, 0.918);
  }

  .cd-accordion-menu li span {
      float: right;
  }

  .cd-accordion-menu label, .cd-accordion-menu a {
    position: relative;
    display: block;
    padding: 18px 18px 18px 18px;
    box-shadow: inset 0 -1px #cecece;
    color: #696969;
  }
  .no-touch .cd-accordion-menu label:hover,
  .no-touch .cd-accordion-menu a:hover {
    background: #52565d;
  }
  .cd-accordion-menu label::before,
  .cd-accordion-menu label::after,
  .cd-accordion-menu a::after {
    /* icons */
    // content: '';
    // display: inline-block;
    // width: 16px;
    // height: 16px;
    // position: absolute;
    // top: 50%;
    // transform: translateY(-50%);
  }
  .cd-accordion-menu label {
    cursor: pointer;
  }

  .cd-accordion-menu label span {
    float: right;
    color: #828282;
  }

  .title {
    float: none !important;
    color: #696969 !important;
    font-weight: 500 !important;
    margin-right: 10%;
  }


  .cd-accordion-menu label i {
    float: right;
    color: #696969;
  }

  .cd-accordion-menu li.file > label::before {
  }
  .cd-accordion-menu li.folder > label::before {
    // content: "\f054";
  }

  .cd-accordion-menu li.file > label::before {
  }
  .cd-accordion-menu li.add > label::before {
    // content: "\f067";
  }


  .cd-accordion-menu label::before {
    /* arrow icon */
    // font: normal normal normal 14px/1 FontAwesome;
    // left: 8px;
    // transform: translateY(-50%);
    // transition: transform 0.3s;
  }
  .cd-accordion-menu label.open::before {
    // transform: translateY(-25%) rotate(90deg);
  }

  .cd-accordion-menu ul label,
  .cd-accordion-menu ul a {
    background: #000;
    box-shadow: inset 0 -1px #cecece;
    // padding-left: 82px;
  }

  .cd-accordion-menu ul label {
    background: #ffffff98  !important;
  }

  .no-touch .cd-accordion-menu ul label:hover,
  .no-touch .cd-accordion-menu ul a:hover {
    background: #3c3f45;
  }
  .cd-accordion-menu > li:last-of-type > label,
  .cd-accordion-menu > li > ul > li:last-of-type a {
    box-shadow: none;
  }
  .cd-accordion-menu ul label::before {
    // left: 20px;
  }
  .cd-accordion-menu ul label::after,
  .cd-accordion-menu ul a::after {
    left: 59px;
  }
  .cd-accordion-menu ul ul label,
  .cd-accordion-menu ul ul a {
    // padding-left: 100px;
  }
  .cd-accordion-menu ul ul label::before {
    // left: 54px;
  }
  .cd-accordion-menu ul ul label::after,
  .cd-accordion-menu ul ul a::after {
    left: 77px;
  }
  .cd-accordion-menu ul ul ul label,
  .cd-accordion-menu ul ul ul a {
  }
  .cd-accordion-menu ul ul ul label::before {
    // left: 72px;
  }
  .cd-accordion-menu ul ul ul label::after,
  .cd-accordion-menu ul ul ul a::after {
    // left: 95px;
  }

  .file {
    label {
      cursor: unset;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/documents/DocumentsScreen.vue